import { useEffect } from 'react'

const TIMING = {
  INITIAL_DELAY: 200,
  SCROLL_DELAY: 300
}

const SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'start',
  inline: 'nearest'
}

const ELEMENT_SELECTORS = [
  'WebComponentContainer-breadcrumb', 
  '[id*="WebComponentContainer-breadcrumb"]', 
  'ico-breadcrumb'
]

const findBreadcrumbElement = (breadcrumbRef) => {
  return (
    document.getElementById(ELEMENT_SELECTORS[0]) || 
    document.querySelector(ELEMENT_SELECTORS[1]) || 
    breadcrumbRef.current || 
    document.querySelector(ELEMENT_SELECTORS[2])
  )
}

const scrollToTop = (isInIframe) => {
  if (isInIframe) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    window.scrollTo(0, 0)
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

const useScrollManagement = (currentStep, breadcrumbRef) => {
  useEffect(() => {
    const isInIframe = window !== window.parent

    const handleScrollToTop = () => {
      const targetElement = findBreadcrumbElement(breadcrumbRef)
      
      if (!targetElement) return

      targetElement.scrollIntoView(SCROLL_OPTIONS)

      setTimeout(() => {
        scrollToTop(isInIframe)
      }, TIMING.SCROLL_DELAY)
    }

    setTimeout(handleScrollToTop, TIMING.INITIAL_DELAY)
  }, [currentStep, breadcrumbRef])
}

export default useScrollManagement